import { useAtom } from "jotai";
import { detectVolumeAtom, currentUserAgreementAtom } from "./store";
import { ReactElement } from "react";
import { DEBUG_AUDIO_PLAYER } from "./environments";

function DebugTools(): ReactElement | null {
  const [, setHasAgreed] = useAtom(currentUserAgreementAtom);
  const [, setDetectVolume] = useAtom(detectVolumeAtom);

  const handleClear = (): void => {
    setHasAgreed(null);
    setDetectVolume(-1);
  };

  if (process.env.NODE_ENV !== "development" && !DEBUG_AUDIO_PLAYER) {
    return null; // 本番では表示しない
  }

  return (
    <div style={{ position: "fixed", bottom: 0, right: 0 }}>
      <button onClick={handleClear}>同意フラグ、音量閾値をリセット</button>
    </div>
  );
}

export default DebugTools;
